export default __webpack_public_path__ + "static/media/i2.f649e605.jpg";